import React, { useEffect, useMemo, useState } from "react";
import EnhancedDropdownComponent from "./EnhancedDropdownComponent.js";
import { Box } from "@material-ui/core";
import { WorkshopPlanningIndicatorsWithOutletIdAndIsCompetenceTrueUrl } from "../../../constants/apiUrls.js";
import DataSourceDropdownComponent from "./DataSourceDropdownComponent.js";

const IndicatorsDropdown = ({
  resources,
  indicator,
  indicators,
  outletId,
  onIndicatorChange,
  onRequestStart,
  onRequestEnd,
  filter,
  containerClass,
  helperText = null,
  defaultValue = null,
  inputName = "indicator",
  id = "indicators-dropdown",
  disabled = false,
  required = false,
}) => {
  return (
    <DataSourceDropdownComponent
      id={id}
      labelText={resources["Indicator"]}
      value={indicator}
      placeholder={defaultValue ?? resources["All"]}
      values={indicators}
      handleChange={onIndicatorChange}
      inputName={inputName}
      addMarginBottom={false}
      helperText={helperText}
      disabled={disabled}
      required={required}
      onRequestStart={onRequestStart}
      onRequestEnd={onRequestEnd}
      containerClass={containerClass}
      sourceUrl={WorkshopPlanningIndicatorsWithOutletIdAndIsCompetenceTrueUrl(outletId)}
      map={i => ({ key: i.id, name: i.description })}
      filter={filter}
      sort={(a, b) => (a.description.toLowerCase() > b.description.toLowerCase()) ? 1 : -1}
    />
  );
};

export default IndicatorsDropdown;
